import { Component, Input, OnInit } from '@angular/core';
import {
  changeCourseTypes,
  checkTypeOrderCourse,
  SlideInOutAnimation,
} from '@app/helpers';
import { courseTypeOrders, courseTypes } from '@app/constants';
import * as moment from 'moment';
@Component({
  selector: 'app-student-course-airplane',
  templateUrl: './student-course-airplane.component.html',
  styleUrls: ['./student-course-airplane.component.scss'],
  animations: [SlideInOutAnimation],
})
export class StudentCourseAirplaneComponent implements OnInit {
  @Input('formGroup') formGroup: any;
  @Input('form') form: any = [];
  @Input('submitted') submitted = false;
  @Input('isEdit') isEdit = false;
  protected readonly checkTypeOrderCourse = checkTypeOrderCourse;
  protected readonly changeCourseTypes = changeCourseTypes;

  constructor() {}

  ngOnInit(): void {}

  public changeCourse(): void {
    if (!this.form['b_plane'].value) {
      courseTypeOrders.forEach((courseTypeOrder) => {
        courseTypes.forEach((courseType) => {
          let key: string = `b_${courseTypeOrder}${courseType}`;
          this.form[key].setValue(false);
          changeCourseTypes(key, this.form);
        });
      });
    }
  }

  public changeDate(event: any): void {
    if (event.data) {
        const deliveryDate = moment(event.data, 'YYYY/MM/DD');
        const expirationDate = deliveryDate.add(1, 'year').subtract(1, 'day');

        const controlMappings: any = {
            'b_firstClassBasicDeliveryDate': 'b_firstClassBasicExpirationDate',
            'b_firstClassDaytimeOnlyDeliveryDate': 'b_firstClassDaytimeOnlyExpirationDate',
            'b_firstClassVisualLineOfSightDeliveryDate': 'b_firstClassVisualLineOfSightExpirationDate',
            'b_firstClassWeightLimitedDeliveryDate': 'b_firstClassWeightLimitedExpirationDate',
            'b_secondClassBasicDeliveryDate': 'b_secondClassBasicExpirationDate',
            'b_secondClassDaytimeOnlyDeliveryDate': 'b_secondClassDaytimeOnlyExpirationDate',
            'b_secondClassVisualLineOfSightDeliveryDate': 'b_secondClassVisualLineOfSightExpirationDate',
            'b_secondClassWeightLimitedDeliveryDate': 'b_secondClassWeightLimitedExpirationDate',
        };
        const expirationControlName = controlMappings[event.value];
        if (expirationControlName) {
            this.form[expirationControlName].setValue(expirationDate.toDate());
        }
    }
  }

}
